var map = {
	"./BasisGrotesque-Regular.ttf": 1482,
	"./BasisGrotesque-Regular.woff": 1483,
	"./BasisGrotesque-Regular.woff2": 507,
	"./BasisGrotesqueProWinnowBeta12-Regular.ttf": 1484,
	"./BasisGrotesqueProWinnowBeta12-Regular.woff": 1485,
	"./BasisGrotesqueProWinnowBeta12-Regular.woff2": 1486,
	"./SangBleuVersailles-Regular-WebM.ttf": 1487,
	"./SangBleuVersailles-Regular-WebM.woff": 1488,
	"./SangBleuVersailles-Regular-WebM.woff2": 1489,
	"./icomoon": 671,
	"./icomoon.json": 671,
	"./icomoon.ttf": 1490,
	"./icomoon.woff": 1491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1481;